import {AppForm as RawAppForm} from './AppForm';
import {Body} from './primitives/Body';
import {Field} from './primitives/Field';
import {FieldInput} from './primitives/FieldInput';
import {FieldLabel} from './primitives/FieldLabel';
import {FieldPasswordInput} from './primitives/FieldPasswordInput';
import {FieldWarningMessage} from './primitives/FieldWarningMessage';

type AppFormType = typeof RawAppForm & {
    Field: typeof Field;
    FieldLabel: typeof FieldLabel;
    FieldInput: typeof FieldInput;
    FieldPasswordInput: typeof FieldPasswordInput;
    FieldWarningMessage: typeof FieldWarningMessage;
    Body: typeof Body;
};

export const AppForm = Object.assign(RawAppForm, {
    Field,
    FieldLabel,
    FieldInput,
    FieldWarningMessage,
    Body,
    FieldPasswordInput,
}) as AppFormType;
